import React from 'react';
import ReactDOM from 'react-dom';
import '@src/slide/infrastructure/module/dependent/uncommon-font/load-css';
import set from 'lodash/set';
import get from 'lodash/get';
import has from 'lodash/has';
import '@src/slide/infrastructure/module/dependent/fetch-data-event';
import '@src/slide/infrastructure/module/independent/polyfill';
import '@src/slide/infrastructure/module/dependent/performance/begin-time';
import '@src/slide/infrastructure/module/dependent/console/clear-console';
import '@src/slide/infrastructure/module/dependent/report/js-error/js-error-monitor';
import '@src/slide/infrastructure/module/dependent/performance/data/client-vars';
import '@src/slide/infrastructure/module/dependent/performance/html/html';
import { weblogIdentity } from '@src/slide/infrastructure/module/dependent/report/log/weblog-default';
import AegisWrapper from '@src/slide/infrastructure/module/dependent/report/platform/aegis';
import { resetDefaultTdwData } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { AppEntryType, IInfrastructureBase } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import SwitchSystemManager from '@src/slide/infrastructure/module/dependent/config/switch-system';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { IS_PRIVATE_WECOM } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import ua from '@tencent/docs-user-agent';
import { getUid } from '@tencent/docs-login';
import { isPreview } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';

export class InfrastructureBase implements IInfrastructureBase {
    /**
     * slide 初始化时间戳
     */
    public initDatetime = new Date();
    // 记录 slide 首页渲染完成时间
    private firstPageTimeStamp: number;

    public init(): void {
        // lodash兼容初始化
        this.initLodash();
        // 初始化tdw
        this.initReport();
        // 初始化开关系统
        this.initSwitchConfig();
        this.initOpenTelemetry();
        this.registerEvents();

        this.ignoreMqq();
    }

    public getEntryType(): AppEntryType {
        return AppEntryType.PC_EDIT;
    }

    protected initReport() {}

    private initLodash(): void {
        window._ = {
            set,
            get,
            has,
        };
    }

    private initSwitchConfig(): void {
        SwitchSystemManager.initConfigSDK();
    }

    private initOpenTelemetry(): void {
        eventBus.on(EventKeys.FIRST_PAGE_DISPLAY, () => {
            this.firstPageTimeStamp = Date.now();
        });
        // 天机阁全链路上报
        import('@tencent/docs-opentelemetry').then(({ registerWebTracerProvider, registerRUM, customizeFirstScreen }) => {
            registerWebTracerProvider({
                serviceName: 'slide',
                tenantConfig: IS_PRIVATE_WECOM ? {
                    TRACE_URL: `https://${appConfigInstance.getConfig('runtime.domainName')}/tpstelemetry/v1/traces`,
                } : {},
            });
            if (isPreview() && !IS_PRIVATE_WECOM) {
                registerRUM({ serviceName: 'websdk-slide', needManualReportFirstScreen: true });
                if (this.firstPageTimeStamp) {
                    customizeFirstScreen(this.firstPageTimeStamp);
                }
            }
        })
            .catch((err) => {
                global.log.error(`@tencent/docs-opentelemetry load error - ${err}`);
            });
    }

    private registerEvents(): void {
        eventBus.once(EventKeys.SLIDE_APP_READY, () => {
            resetDefaultTdwData();
            const uin = getUid() || window?.basicClientVars?.userInfo?.tinyId || '';
            if (process.env.NODE_ENV === 'development') {
                // 初始化 Aegis
                const { aegis } = AegisWrapper.getInstance();

                aegis.setConfig({ uin });
            }
            // weblog绑定uid
            weblogIdentity(uin);
        });
    }

    private ignoreMqq(): void {
        // 会议场景屏蔽 mqq
        if (ua.isTencentMeeting || ua.isWxWorkTencentMeeting || ua.isTencentMeetingRooms) {
            global.mqq = null;
            window.mqq = null;
        }
    }
}

global.React = React;
global.ReactDOM = ReactDOM;
